/* @flow */
import { ActionTypes } from 'constants/QuickPromotionConstants';
import { dispatcher } from 'lib/Dispatcher';

const QuickPromotionActions = {
  recordDismissal(promotion: Object, response: string): void {
    promotion.recordDismissal(response).then(() => {
      dispatcher.dispatch({
        promotion,
        type: ActionTypes.PROMOTION_DISMISSED,
      });
    }).catch(e => console.error('QuickPromotionActions recordDismissal failed', e));
  },
};

export default QuickPromotionActions;



// WEBPACK FOOTER //
// ./src/actions/QuickPromotionActions.js